import React from "react";
import Card from "../../component/Card";
import "./style.scss";
import GlobalInventoryReportTable from "../../component/GlobalInventoryReportTable";

const GlobalInventoryReport: React.FC = () => {
	
	return (
		<div className="home-wrapper table-layout">
			<div className="mailchimp-table-wrapper">
				<GlobalInventoryReportTable />
			</div>
		</div>
	);
};

export default GlobalInventoryReport;
